<span class="tc-ag-grid__icons-container">
                    <button mat-icon-button matTooltip="{{params.title? params.title:'Action' | translate}}" class="tc-m-0 tc-icon-block__icon tc-icon-block__icon--active" (click)="onClick()" >
                        <mat-icon aria-hidden="false" aria-label="">{{params.icon}}</mat-icon>
                    </button>
                </span>